export default {
  data() {
    return {
      selected: [],
      tableData: []
    }
  },
  methods: {
    onSelect(items) {
      this.selected = items
    }
  }
}
